import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import '../styles/Contact.css';

const Contact = ({ translations, language }) => {
  const [ref, inView] = useInView({ threshold: 0.3, triggerOnce: true });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    budget: '',
    message: ''
  });

  const contactData = {
    en: {
      title: 'Get In Touch',
      subtitle: 'Ready to Transform Your Marketing?',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        company: 'Company Name',
        budget: 'Project Budget',
        message: 'Project Details',
        submit: 'Send Message',
        newsletter: 'Subscribe to Marketing Insights Newsletter'
      },
      budgetOptions: [
        'Select Budget Range',
        '$5K - $10K',
        '$10K - $25K',
        '$25K - $50K',
        '$50K - $100K',
        '$100K+'
      ],
      contact: {
        email: 'codevibe01@gmail.com',
        phone: '+2001080145935',
        location: 'Cairo, Egypt'
      },
      social: {
        title: 'Follow Zezo',
        platforms: ['LinkedIn', 'Twitter', 'Instagram', 'YouTube']
      }
    },
    ar: {
      title: 'تواصل معنا',
      subtitle: 'مستعد لتحويل تسويقك؟',
      form: {
        name: 'الاسم الكامل',
        email: 'عنوان البريد الإلكتروني',
        company: 'اسم الشركة',
        budget: 'ميزانية المشروع',
        message: 'تفاصيل المشروع',
        submit: 'إرسال الرسالة',
        newsletter: 'اشترك في نشرة رؤى التسويق'
      },
      budgetOptions: [
        'اختر نطاق الميزانية',
        '5 آلاف - 10 آلاف دولار',
        '10 آلاف - 25 ألف دولار',
        '25 ألف - 50 ألف دولار',
        '50 ألف - 100 ألف دولار',
        '100 ألف دولار+'
      ],
      contact: {
        email: 'codevibe01@gmail.com',
        phone: '+2001080145935',
        location: 'القاهرة، مصر'
      },
      social: {
        title: 'تابع زيزو',
        platforms: ['LinkedIn', 'Twitter', 'Instagram', 'YouTube']
      }
    }
  };

  const data = contactData[language];

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <section id="contact" className="contact-section section" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title gradient-text">{data.title}</h2>
          <p className="section-subtitle">{data.subtitle}</p>
        </motion.div>

        <div className="contact-content">
          <motion.div
            className="contact-form-container"
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <form className="contact-form glass-morphism" onSubmit={handleSubmit}>
              <div className="form-group">
                <motion.input
                  type="text"
                  name="name"
                  placeholder={data.form.name}
                  value={formData.name}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                  whileFocus={{ scale: 1.02 }}
                />
                <div className="input-glow"></div>
              </div>

              <div className="form-group">
                <motion.input
                  type="email"
                  name="email"
                  placeholder={data.form.email}
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                  whileFocus={{ scale: 1.02 }}
                />
                <div className="input-glow"></div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <motion.input
                    type="text"
                    name="company"
                    placeholder={data.form.company}
                    value={formData.company}
                    onChange={handleInputChange}
                    className="form-input"
                    whileFocus={{ scale: 1.02 }}
                  />
                  <div className="input-glow"></div>
                </div>

                <div className="form-group">
                  <motion.select
                    name="budget"
                    value={formData.budget}
                    onChange={handleInputChange}
                    className="form-input"
                    whileFocus={{ scale: 1.02 }}
                  >
                    {data.budgetOptions.map((option, index) => (
                      <option key={index} value={index === 0 ? '' : option}>
                        {option}
                      </option>
                    ))}
                  </motion.select>
                  <div className="input-glow"></div>
                </div>
              </div>

              <div className="form-group">
                <motion.textarea
                  name="message"
                  placeholder={data.form.message}
                  value={formData.message}
                  onChange={handleInputChange}
                  className="form-input form-textarea"
                  rows="5"
                  required
                  whileFocus={{ scale: 1.02 }}
                ></motion.textarea>
                <div className="input-glow"></div>
              </div>

              <div className="form-group checkbox-group">
                <label className="checkbox-label">
                  <input type="checkbox" className="checkbox-input" />
                  <span className="checkbox-custom"></span>
                  <span className="checkbox-text">{data.form.newsletter}</span>
                </label>
              </div>

              <motion.button
                type="submit"
                className="btn-futuristic primary submit-btn"
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                {data.form.submit}
                <i className="fas fa-paper-plane"></i>
              </motion.button>
            </form>
          </motion.div>

          <motion.div
            className="contact-info"
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="contact-card glass-morphism">
              <h3 className="contact-card-title">{language === 'en' ? 'Direct Contact' : 'التواصل المباشر'}</h3>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="contact-details">
                  <span className="contact-label">{language === 'en' ? 'Email' : 'البريد الإلكتروني'}</span>
                  <a href={`mailto:${data.contact.email}`} className="contact-value">
                    {data.contact.email}
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="contact-details">
                  <span className="contact-label">{language === 'en' ? 'Phone' : 'الهاتف'}</span>
                  <a href={`tel:${data.contact.phone}`} className="contact-value">
                    {data.contact.phone}
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="contact-details">
                  <span className="contact-label">{language === 'en' ? 'Location' : 'الموقع'}</span>
                  <span className="contact-value">{data.contact.location}</span>
                </div>
              </div>
            </div>

            <div className="social-card glass-morphism">
              <h3 className="social-card-title">{data.social.title}</h3>
              <div className="social-links">
                {data.social.platforms.map((platform, index) => (
                  <motion.a
                    key={index}
                    href="#"
                    className="social-link"
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <i className={`fab fa-${platform.toLowerCase()}`}></i>
                  </motion.a>
                ))}
              </div>
            </div>

            <div className="response-time glass-morphism">
              <div className="response-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div className="response-text">
                <h4>{language === 'en' ? 'Quick Response' : 'استجابة سريعة'}</h4>
                <p>{language === 'en' ? 'I typically respond within 24 hours' : 'عادة ما أرد خلال 24 ساعة'}</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* WhatsApp Float Button */}
      <motion.a
        href="https://wa.me/2001080145935"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <i className="fab fa-whatsapp"></i>
      </motion.a>
    </section>
  );
};

export default Contact;